
export default {
  name: "ContentType2",
  props: {
    introList: {
      type: Array,
      default () {
        return []
      }
    },
    imageList: {
      type: Array,
      default () {
        return []
      }
    },
    imageStyle: {
      type: Object,
      default () {
        return {}
      }
    },
    currentInx: {
      type: Number,
      default: 0
    }
  }
}
